const ATTRS_LABEL = {
  name: "姓名",
  gender: "性别",
  tel: "电话",
  email: "邮箱",
  qq: "QQ",
  weixin: "微信",
  weixin_url: "微信二维码",
  weibo: "微博",
  address: "地址",
  comment: "备注",
  age: "年龄",
  tag: "顾客标签",
  created_on: "创建顾客时间",
  updated_on: "更新时间",
  latest_conv_on: "最近一次对话时间",
  latest_visit_on: "最近一次访问时间",
  contact: "联系人",
  __openid: "openid",
  click_id: "小组件点击ID",
};

export default ATTRS_LABEL;
